module.exports = __webpack_public_path__ + "img/audio-annotation-examples.04c4f98a.jpg";